import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-orrecord-fluids',
  templateUrl: './orrecord-fluids.component.html',
  styleUrls: ['./orrecord-fluids.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class OrrecordFluidsComponent implements OnInit {
  columnsToDisplay = ['Name', 'Description', 'IsActive'];
  headercolumnsToDisplay = ['Fluids', 'Description', 'Is Active'];
  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  orrecordfluidsform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.orrecordfluidsform = this.formBuilder.group({

      name: ['',],
      isactive: ['',],
      description: ['',],
      names: ['',],
      isactivee: ['',],
      descriptionn: ['',]

    });

  }

  get f() { return this.orrecordfluidsform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.orrecordfluidsform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.orrecordfluidsform.value))
  }
}

